import React from 'react';

import {
  Criterium,
  CriteriumCompetitors,
  CriteriumTrafficPopularitySection
} from '@hydra/common/criterium';

import hasCritData from '@hydra/utils/hasCritData';

import { CriteriumInterface, ReviewData } from '@hydra/types/review';

interface TrafficPopularityCriterium extends CriteriumInterface {
  data: {
    globalRank: number | null
    tldRank: number | null
    tld: string | null
  }
}

export const TrafficPopularity = ({
  criterium,
  competitors = []
}: {
  criterium: TrafficPopularityCriterium
  competitors: Array<ReviewData>
}) => {
  const { data, url, type } = criterium;
  const singleContent = <CriteriumTrafficPopularitySection {...data} />;
  let compContent;
  if (competitors.length > 0) {
    const compComponents = [
      { component: singleContent, url },
      ...competitors.map(({ criteria }) => {
        if (!hasCritData(criteria[type])) {
          return null;
        }
        const { data, url } = criteria[type];
        return {
          component: <CriteriumTrafficPopularitySection {...data} />,
          url
        };
      })
    ];
    compContent = <CriteriumCompetitors competitors={compComponents} />;
  }

  return (
    <Criterium
      criterium={criterium}
      variables={{ domain: url, url }}
    >
      {compContent || singleContent}
    </Criterium>
  );
};

export default React.memo(TrafficPopularity);
